export const TAG_NORMAL_STYLE = { color: '#FFFFFF', textColor: '#A0ACB5' }
export const TAG_ACTIVE_STYLE = { color: '#2FD0D5', textColor: '#FFFFFF' }
